import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, QuantityUnit } from "__generated__/graphql";

export const TeuSchema: RegistryItem = {
	[AgreementTypeEnum.Teu]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.QuantityUnit,
				quantityUnit: QuantityUnit.Teu,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.quantityUnit": { rules: { hidden: true } },
		},
	},
};
